import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, unref as _unref, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "container block" }
const _hoisted_2 = { class: "page-header" }
const _hoisted_3 = { class: "list" }

import { ref } from 'vue'
import { CompanyFacilityDto, FacilityDto, getCompanyFacilityList, deleteCompanyFacility } from '@/api/attendance'
import CompanyCard from '@/views/attendance/components/company-card.vue'
import MachineEditor from '@/views/attendance/components/machine-editor.vue'
import router from '@/router'
import { ElMessageBox, ElMessage } from 'element-plus'

export default /*@__PURE__*/_defineComponent({
  __name: 'machine',
  setup(__props) {

const emptyImg = require('@/assets/attendance/empty.png')

const loading = ref(false)
const machineEditor = ref() as any
const companyList = ref([] as any)
const companyListLoading = ref(false)

const onSetup = () => {
    getCompanyList()
}

const getCompanyList = async () => {
    loading.value = true
    companyList.value = await getCompanyFacilityList()
    loading.value = false
}

const onCreateMachine = () => {
    machineEditor.value.open()
}

const onCreateMachineFromCompany = (company: CompanyFacilityDto) => {
    machineEditor.value.open({
        serveCompanyId: company.serveCompanyId,
        serveCompanyName: company.serveCompanyName
    })
}

const onEditMachine = (machine: FacilityDto) => {
    machineEditor.value.open({
        ...machine
    })
}

const onRemoveMachine = async (machine: FacilityDto) => {
    console.log('删除操作')
    await ElMessageBox.confirm('您正在删除当前绑定的考勤机，删除后考勤数据将消失，确定删除？', '删除提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
    })
    await deleteCompanyFacility({ id: machine.id })
    ElMessage.success('删除成功')
    getCompanyList()
    console.log('考勤机信息删除成功')
}

const onDetailMachine = (machine: FacilityDto) => {
    router.push({
        path: `/attendance/detail/${machine.id}`,
        query: {
            serveCompanyId: machine.serveCompanyId,
            name: machine.name
        }
    })
}
onSetup()


return (_ctx: any,_cache: any) => {
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_space = _resolveComponent("el-space")!
  const _component_el_empty = _resolveComponent("el-empty")!
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[1] || (_cache[1] = _createElementVNode("div", null, "考勤机列表", -1)),
      _createElementVNode("div", null, [
        _createElementVNode("div", {
          class: "create mini",
          onClick: onCreateMachine
        }, [
          _createVNode(_component_el_space, null, {
            default: _withCtx(() => [
              _createVNode(_component_el_icon, { class: "el-icon-plus" }),
              _cache[0] || (_cache[0] = _createElementVNode("span", null, "添加考勤机", -1))
            ]),
            _: 1
          })
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(companyList.value, (item) => {
        return (_openBlock(), _createBlock(CompanyCard, {
          key: item.id,
          data: item,
          class: "company",
          onCreateMachine: onCreateMachineFromCompany,
          onEditMachine: onEditMachine,
          onRemoveMachine: onRemoveMachine,
          onDetailMachine: onDetailMachine
        }, null, 8, ["data"]))
      }), 128)),
      _cache[2] || (_cache[2] = _createElementVNode("div", { class: "company" }, null, -1)),
      _cache[3] || (_cache[3] = _createElementVNode("div", { class: "company" }, null, -1)),
      _cache[4] || (_cache[4] = _createElementVNode("div", { class: "company" }, null, -1))
    ]),
    (!loading.value && !companyList.value.length)
      ? (_openBlock(), _createBlock(_component_el_empty, {
          key: 0,
          image: _unref(emptyImg)
        }, {
          description: _withCtx(() => _cache[5] || (_cache[5] = [
            _createElementVNode("div", { class: "description" }, [
              _createElementVNode("div", null, "暂无可用的考勤机"),
              _createElementVNode("div", null, "绑定后可智能计算工时")
            ], -1)
          ])),
          _: 1
        }, 8, ["image"]))
      : _createCommentVNode("", true),
    _createVNode(MachineEditor, {
      ref_key: "machineEditor",
      ref: machineEditor,
      onUpdateSuccess: getCompanyList
    }, null, 512)
  ])), [
    [_directive_loading, companyListLoading.value]
  ])
}
}

})